
  import ScreenSize from '@/mixins/ScreenSize';
  import Events from '@/events/Events';
  import clearableTabIndex from '@/mixins/clearableTabIndex';

  export default {
    name: 'RegistrationOrLoginDialog',
    components: {
      EmailCheckForm: () =>
        import(
          '@/components/candidate/RegistrationOrLoginDialog/EmailCheckForm'
        ),
      RegistrationForm: () =>
        import(
          '@/components/candidate/RegistrationOrLoginDialog/RegistrationForm'
        ),
      LoginForm: () =>
        import('@/components/candidate/RegistrationOrLoginDialog/LoginForm'),
      RegistrationSuccessPage: () =>
        import(
          '@/components/candidate/RegistrationAndApplicationDialog/RegistrationSuccessPage'
        ),
      ThankYouPage: () =>
        import(
          '@/components/candidate/RegistrationAndApplicationDialog/ThankYouPage'
        ),
    },
    mixins: [clearableTabIndex, ScreenSize],
    props: {
      buttonClass: {
        type: String,
        required: false,
        default: '',
      },
      textButton: {
        type: Boolean,
        required: false,
        default: false,
      },
      blockButton: {
        type: Boolean,
        required: false,
        default: false,
      },
      openDirectDialog: {
        type: String,
        required: false,
        default: '',
      },
      job: {
        type: Object,
        required: false,
        default: () => {},
      },
      position: {
        type: String,
        required: false,
        default: 'NULL',
      },
    },
    data() {
      return {
        dialog: false,
        dialogWidth: 600,
        page: null,
        currentEmail: '',
      };
    },
    watch: {
      dialog(val) {
        if (
          val === true &&
          !this.$route.query.success &&
          !this.$route.query.successApplication
        ) {
          this.$emitWithClientData(
            this.job
              ? Events.RegistrationBeforeApplicationOpened
              : Events.RegistrationOrLoginOpened,
            {
              jobPostingId: this.job?.id,
            }
          );
        }
      },
    },
    created() {
      if (this.openDirectDialog && this.openDirectDialog !== '') {
        if (this.openDirectDialog === 'registrationAndApplication') {
          this.openDialog('checkEmail');
        } else {
          this.openDialog(this.openDirectDialog);
        }
      }
    },
    methods: {
      removeQueryParam() {
        const updatedQuery = {...this.$route.query};
        if (this.$route.query.success) {
          delete updatedQuery.success;
        }
        if (this.$route.query.successRegister) {
          delete updatedQuery.successRegister;
        }
        if (this.$route.query.registration) {
          delete updatedQuery.registration;
        }
        this.$router.push({path: this.$route.path, query: updatedQuery});
      },
      closeDialog(step) {
        if (step) {
          this.$emitWithClientData(
            this.job
              ? Events.RegistrationBeforeApplicationStepClosed
              : Events.RegistrationOrLoginStepClosed,
            {
              step: step,
              jobPostingId: this.job?.id,
            }
          );
        }
        this.dialog = false;
        this.$emit('close-dropdown-menu');
      },
      changePage(page) {
        this.page = page;

        if (page === 'login') {
          this.$emitWithClientData(
            this.job
              ? Events.RegistrationBeforeApplicationStepStarted
              : Events.RegistrationOrLoginStepStarted,
            {
              step: 'Login',
              jobPostingId: this.job?.id,
            }
          );
        } else if (page === 'registration') {
          this.$emitWithClientData(
            this.job
              ? Events.RegistrationBeforeApplicationStepStarted
              : Events.RegistrationOrLoginStepStarted,
            {
              step: 'Registration',
              jobPostingId: this.job?.id,
            }
          );
        }
      },
      openRegistrationForm(on) {
        return ($event) => {
          on.click($event);
          this.page = 'registration';
          this.$emitWithClientData(
            this.job
              ? Events.RegistrationBeforeApplicationStepStarted
              : Events.RegistrationOrLoginStepStarted,
            {
              step: 'Registration',
              jobPostingId: this.job?.id,
            }
          );
        };
      },
      openLoginForm(on) {
        return ($event) => {
          on.click($event);
          this.page = 'login';
          this.$emitWithClientData(
            this.job
              ? Events.RegistrationBeforeApplicationStepStarted
              : Events.RegistrationOrLoginStepStarted,
            {
              step: 'Login',
              jobPostingId: this.job?.id,
            }
          );
        };
      },
      openDialog(page) {
        if (page === 'registrationSuccess') {
          this.$emitWithClientData(Events.ThankYouPageOpened, {
            type: this.job
              ? 'RegistrationBeforeApplication'
              : 'RegistrationOrLogin',
          });
          this.dialogWidth = 900;
        }
        this.dialog = true;
        this.page = page;
      },
      openCheckEmailForm(on) {
        return ($event) => {
          on.click($event);
          this.page = 'checkEmail';

          this.$emitWithClientData(
            this.job
              ? Events.RegistrationBeforeApplicationStepStarted
              : Events.RegistrationOrLoginStepStarted,
            {
              step: 'EmailCheck',
              jobPostingId: this.job?.id,
            }
          );
        };
      },
      openRegistrationSuccess(on) {
        return ($event) => {
          on.click($event);
          this.page = 'registrationSuccess';
        };
      },
      setCurrentEmail(email) {
        this.currentEmail = email;
      },
    },
  };
